import {
	Component,
	ViewEncapsulation,
	Input,
	Output,
	ChangeDetectorRef,
	Inject,
	NgZone,
	OnInit,
	EventEmitter,
	ChangeDetectionStrategy
} from '@angular/core';

import { UIColorModel } from '../../../services/ui.color.model.service';


@Component({
	selector: 'password-input-filled',
	inputs: ['supportingtext', 'errormode'],
	outputs: ['value'],
	changeDetection: ChangeDetectionStrategy.Default,

	template: 	`
		<div class="_text-input-filled-container {{_cssClass}}" 
			font-family surfaceVariantColor
			[style.borderBottom]=_borderBottom>
			<div *ngIf="_leadingIcon.length > 0" class="leading-icon">
				<i class="mdi mdi-{{_leadingIcon}}"></i>
			</div>
			<input #ifield class="input-field" type={{_inputType}}
				(focus)="focusState()" 
				(focusout)="focusOutState()" 
				(keyup)="onKey(ifield.value)" onSurface>
			<div *ngIf="_trailingIcon.length > 0" class="trailing-icon-wrapper">
					<i class="mdi mdi-{{_trailingIcon}}"
					(click)=toggleHidePassword()
					[style.color]=_trailingIconColor></i>
			</div>
			<span class="label" [style.color]=_labelTxtColor>{{_labelTxt}}</span>
			<div *ngIf="_supportingText.length > 0" class="text-input-supporting-text" 
			[style.color]=_supportingTextColor>{{_supportingText}}</div>
		</div>
	`,

})


export class InputPasswordFieldFilled {
	@Output()
	value = new EventEmitter();

	@Input()
	set supportingtext(value: string) { this.setSupportingText(value); }
	set errormode(value: boolean) { this.setErrorMode(value); }


    uiColorModel: UIColorModel
	_inputType: string = "password"
	_leadingIcon: string = ""

	_trailingIcon: string = "eye-off"
	_trailingIconPrevious: string = "eye-off"
	_trailingIconColor: string = ""

	_labelTxt: string = "Password";
	_labelTxtColor: string = "";

	_supportingText: string = ""
	_supportingTextColor: string = ""


	_errorModeIcon: string = "close-circle"

	_borderBottom: string = "none"
	_cssClass: string = ""
	_isErrorMode: boolean = false
	_isFocused: boolean = false

	changeDetectorRef: ChangeDetectorRef;
	textValue: string = ""
	constructor(public ref: ChangeDetectorRef, private _uiColorModel: UIColorModel) {
		this.changeDetectorRef = ref
		this.uiColorModel = _uiColorModel
	}


	onKey(e: any) {
		this.value.emit(e);
		this.textValue = e
		if(e.length > 0) {
			this._cssClass = "active-has-icon"
		} else {
			this._cssClass = ""
		}
		this.computeColor()
	}

	setSupportingText(val: string) {
		this._supportingText = val;
		this.computeColor()
	}

	setErrorMode(value: boolean) {
		this._isErrorMode = value
		this.computeColor()
	}

	ngOnInit() {
		this._trailingIcon = "eye-off"
	}

	ngOnDestroy() {
  	}

	toggleHidePassword() {
		if(this._trailingIcon == "eye-off") {
			this._trailingIcon = "eye"
			this._trailingIconPrevious = "eye"
			this._inputType = "text"
		} else {
			this._trailingIcon = "eye-off"
			this._trailingIconPrevious = "eye-off"
			this._inputType = "password"
		}
	}

	isEmpty(): boolean {
		let result = true
		if(this.textValue.length > 0) {
			result = false
		}
		return result
	}

	focusState() {
		this.computeColor()
		this._isFocused = true
		this._cssClass = "active-has-icon"
		if(this._isErrorMode) {
			this._borderBottom = "2px solid " + this.uiColorModel.error
			this._labelTxtColor = this.uiColorModel.error
		} else {
			this._borderBottom = "2px solid " + this.uiColorModel.primary
			this._labelTxtColor = this.uiColorModel.primary
		}
	}

	focusOutState() {
		this.computeColor()
		if(this.isEmpty()) {
			this._cssClass = ""
			this._labelTxtColor = this.uiColorModel.onSurface
		} else {
			this._cssClass = "active-has-icon"
			this._labelTxtColor = this.uiColorModel.primary
		}
		this._isFocused = false
		if(this._isErrorMode == false) {
			this._borderBottom = "none"
		}
		this.changeDetectorRef.detectChanges()
	}

	enabledState() {
	}

	selectedState() {
	}

	errorState() {
	}


	computeColor() {
		if(this._isErrorMode) {
			this._labelTxtColor = this.uiColorModel.error
			this._supportingTextColor = this.uiColorModel.error
			this._trailingIconColor = this.uiColorModel.error
			this._trailingIcon = this._errorModeIcon
			this._borderBottom = "2px solid " + this.uiColorModel.error
		} else {
			this._labelTxtColor = this.uiColorModel.primary
			this._supportingTextColor = this.uiColorModel.onSurface
			this._trailingIconColor = this.uiColorModel.onSurface
			this._trailingIcon = this._trailingIconPrevious
		}

		if(this.isEmpty()) {
			this._labelTxtColor = this.uiColorModel.onSurface
			this._supportingTextColor = this.uiColorModel.onSurface
			this._trailingIconColor = this.uiColorModel.onSurface
		}

		this.changeDetectorRef.detectChanges()
	}

}
